import React, { RefObject } from 'react';
import { TextField, TextFieldProps, useMediaQuery, useTheme } from '@material-ui/core';

type Props = TextFieldProps & {
  labelForMobile?: string;
};

export const ResponsiveTextField = React.forwardRef<RefObject<any>, Props>(
  ({ labelForMobile, label, ...others }, ref) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return <TextField inputRef={ref} {...others} label={isMobile && labelForMobile ? labelForMobile : label} />;
  }
);
